import React, { Fragment } from "react";
import { defineMessages } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import { REQUIRED } from "assets/scripts/constants/FormMessages";
import getMaxLengthError from "assets/scripts/utils/getMaxLengthError";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
const messages = defineMessages({
    firstNameLabel: {
        id: "forms.profileEdit.firstName.label",
        defaultMessage: "First Name"
    },
    lastNameLabel: {
        id: "forms.profileEdit.lastName.label",
        defaultMessage: "Last Name"
    }
});
export function getErrors(value) {
    return {
        firstName: isEmpty(value.firstName) ? REQUIRED : getMaxLengthError(value.firstName, 50),
        lastName: isEmpty(value.lastName) ? REQUIRED : getMaxLengthError(value.lastName, 50)
    };
}
export default function ProfileNameInputs({ value, errors, backendErrors, onChange }) {
    const handleChange = (update) => onChange({
        ...value,
        ...update
    });
    return (<Fragment>
			<TextFormGroup name="firstName" className="form-group-firstName" label={messages.firstNameLabel} value={value.firstName} onChange={firstName => handleChange({ firstName })} error={errors.firstName} backendError={backendErrors.firstName} required inputProps={{
        autoComplete: "given-name"
    }}/>

			<TextFormGroup name="lastName" className="form-group-lastName" label={messages.lastNameLabel} value={value.lastName} onChange={lastName => handleChange({ lastName })} error={errors.lastName} backendError={backendErrors.lastName} required inputProps={{
        autoComplete: "family-name"
    }}/>
		</Fragment>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileNameInputs/ProfileNameInputs.tsx